import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadConfig } from "./lib/config";
import "./styles.css";

const config = await loadConfig();
createRoot(document.getElementById("root")!).render(<StrictMode><App config={config} /></StrictMode>);
